import * as Yup from "yup";
import { ISchoolModel } from "../models/ISchoolModel";
import { Email } from "@mui/icons-material";



export const getFacilitatorSchoolFormValidations = (
    values: ISchoolModel
): Yup.AnyObjectSchema => {
    const schema: Yup.SchemaOf<ISchoolModel> = Yup.object()
        .shape({
            name: Yup.string().required("School Name is Required"),
            email: Yup.string().email("enter valid email address"),
            mobileNumber: Yup.string().matches(/^[6-9]\d{9}$/, { message: "Please enter valid number.", excludeEmptyString: false }),
            userName: Yup.string().required("Username is Required"),
            password: Yup.string().required("Password is Required").min(6, "Password length must be not less than 6 characters"),
            state: Yup.string().required("State is Required"),
            address: Yup.string().required("Address is Required"),
            chairmanWhatsAppContact: Yup.string().matches(/^[6-9]\d{9}$/, { message: "Please enter valid number.", excludeEmptyString: false }),
            principalWhatsAppContact: Yup.string().matches(/^[6-9]\d{9}$/, { message: "Please enter valid number.", excludeEmptyString: false }),
            programInchargeWhatsAppContact: Yup.string().matches(/^[6-9]\d{9}$/, { message: "Please enter valid number.", excludeEmptyString: false }),
            // foundationPrograms: IFoundationProgram[],
            // olympiadExams: IOlympiadExam[]
        })
        .defined();
    return schema;
};